<template>
    <div class="rule-setting-container">
        <div class="choose-options">
            <el-input placeholder="请输入手机号" v-model="searchInfo.mobile" clearable></el-input>
            <el-input placeholder="请输入坐席名称" v-model="searchInfo.name" clearable></el-input>
            <el-select v-model="searchInfo.week" placeholder="请选择星期" multiple clearable>
                <el-option v-for="item in weekOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>

            <el-date-picker v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="timestamp" clearable :default-time="['00:00:00', '23:59:59']"
                @change="(e) => handleChange(e, 'date_time', 'start_time', 'end_time')">

            </el-date-picker>
            <el-time-picker is-range v-model="time1" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                placeholder="选择时间范围" value-format="timestamp"
                @change="(e) => handleChange(e, 'monment_time', 'start_moment', 'end_moment')">
            </el-time-picker>
            <el-button type="three" @click="getLists()">筛选</el-button>
            <el-button type="three" @click="resetSearchInfo">重置</el-button>
        </div>
        <el-button type="three" size="medium" @click="add">添加规则</el-button>
        <el-table :data="ruleList" style="width: 100%" :header-cell-style="{ background: '#F0F3F7', color: '#39475B' }"
            :cell-style="{
                background: '#FCFDFF',
                'font-size': '14px',
                color: '#8998AC',
            }">
            <el-table-column prop="id" label="ID" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
            <el-table-column prop="name" label="坐席名称" align="center"></el-table-column>
            <el-table-column prop="week" label="星期" align="center">
                <template #default="scope">
                    {{ getWeek(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="date_time" label="日期" align="center">
                <template #default="scope">
                    {{ getFormatDate(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="monment_time" label="时间段" align="center">
                <template #default="scope">
                    {{ getFormatTime(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="slot_val" label="槽值" align="center">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <my-operation :scope="scope" @add="add" @deleteItem="deleteItem"></my-operation>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog :close-on-click-modal="false" :title="getDialogTitle" :visible.sync="isOpened" width="800px"
            :before-close="closeDialog">
            <el-form :model="ruleForm" label-position="right" label-width="100px">
                <el-form-item label="手机号：">
                    <el-input v-model="ruleForm.mobile" placeholder="请输入手机号" />
                </el-form-item>
                <el-form-item label="坐席名称：">
                    <el-input v-model="ruleForm.name" placeholder="请输入坐席名称" />
                </el-form-item>
                <el-form-item label="日期：">
                    <div v-for="(date, index1) in ruleForm.date_time" class="time-select" :key="index1">
                        <el-date-picker v-model="ruleForm.date_time[index1]" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
                            :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                        <OptCard :currentIndex="index1" :currentData="ruleForm.date_time" type="time"
                            @deleteTime="deleteTime(index1, 'date_time')" @addTime="addTime('date_time')" />
                    </div>
                </el-form-item>
                <el-form-item label="星期：">
                    <el-select v-model="ruleForm.week" placeholder="请选择工作日" multiple>
                        <el-option v-for="item in weekOptions" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间段：">
                    <div v-for="(time, index1) in ruleForm.monment_time" :key="index1" class="time-select">
                        <el-time-picker is-range v-model="ruleForm.monment_time[index1]" range-separator="至"
                            start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" value-format="timestamp">
                        </el-time-picker>
                        <OptCard :currentIndex="index1" :currentData="ruleForm.monment_time" type="time"
                            @deleteTime="deleteTime(index1, 'monment_time')" @addTime="addTime('monment_time')" />
                    </div>
                </el-form-item>
                <el-form-item label="槽值：">
                    <el-autocomplete v-model="ruleForm.slot_val" :fetch-suggestions="querySearch" :trigger-on-focus="false"
                        clearable placeholder="请选择槽值" value-key="slot_val" @select="handleSelect" />
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" round @click="closeDialog">取消</el-button>
                <el-button size="medium" round type="primary" @click="confirm">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getRuleList, getSlot, addRule, deleteRule } from '@/api/setBase'
import OptCard from '@/components/setBase/optCard.vue'
import moment from 'moment'
import { isSuccess } from '@/utils'
let isLimit = false
export default {
    components: {
        OptCard,
        'my-operation': () => import('@/components/operation/index.vue'),
    },
    data() {
        return {
            ruleList: [],
            ruleForm: {
                mobile: '',
                name: '',
                date_time: [''],
                week: [],
                monment_time: [''],
                slot_code: '',
                slot_id: '',
                slot_val: ''
            },
            searchInfo: {
                mobile: '',
                name: '',
                week: '',
                date_time: {
                    start_time: '',
                    end_time: ''
                },
                monment_time: {
                    start_moment: '',
                    end_moment: ''
                }
            },
            time: '',
            time1: '',
            isOpened: false,
            optType: 'addRules',
            weekOptions: [
                {
                    label: '星期一',
                    value: 1
                },
                {
                    label: '星期二',
                    value: 2
                },
                {
                    label: '星期三',
                    value: 3
                },
                {
                    label: '星期四',
                    value: 4
                },
                {
                    label: '星期五',
                    value: 5
                },
                {
                    label: '星期六',
                    value: 6
                },
                {
                    label: '星期日',
                    value: 7
                },

            ]
        }
    },
    created() {
        this.getLists()
    },
    computed: {
        getDialogTitle() {
            return this.optType === 'addRules' ? '新增规则' : '编辑规则'
        },
        getWeek() {
            return (row) => {
                if (row.week) {
                    let weekArr = row.week.split(',')
                    const nameArr = weekArr.map(item => {
                        const option = this.weekOptions.find(option => option.value == item)
                        return option.label
                    })
                    return nameArr.join('、')
                }
                return ''
            }
        },
        getFormatDate() {
            return row => {
                let dateTime = row.date_time && JSON.parse(row.date_time)
                if (dateTime) {
                    let str = dateTime.reduce((pre, cur) => {
                        if (cur.start_time) {
                            pre += moment(cur.start_time * 1000).format('YYYY-MM-DD') + ' ~ ' + moment(cur.end_time * 1000).format('YYYY-MM-DD') + '、'
                        }
                        return pre
                    }, '')
                    return str ? str.substring(0, str.length - 1) : ''
                }
                return ''
            }
        },
        getFormatTime() {
            return row => {
                let monmentTime = row.monment_time && JSON.parse(row.monment_time)
                if (monmentTime) {
                    let str = monmentTime.reduce((pre, cur) => {
                        if (cur.start_moment) {
                            pre += moment(cur.start_moment * 1000).format('HH:mm:ss') + ' - ' + moment(cur.end_moment * 1000).format('HH:mm:ss') + '、'
                        }
                        return pre
                    }, '')
                    return str ? str.substring(0, str.length - 1) : ''
                }
                return ''
            }
        },
    },

    methods: {
        async getLists() {
            let searchInfo = {}
            Object.keys(this.searchInfo).forEach(key => {
                let val = this.searchInfo[key]
                if (val) {
                    if (typeof val === 'object') {
                        if (Object.keys(val).some(item => val[item])) {
                            searchInfo[key] = val
                        }
                    } else {
                        searchInfo[key] = val
                    }
                }
            })
            const res = await getRuleList({ page: 1, ...searchInfo })
            this.ruleList = res.data
        },
        add(row) {
            if (row.id) {
                this.ruleForm.id = row.id
                let date_time = row.date_time ? JSON.parse(row.date_time) : ['']
                let monment_time = row.monment_time ? JSON.parse(row.monment_time) : ['']
                this.ruleForm = {
                    id: row.id,
                    mobile: row.mobile,
                    name: row.name,
                    date_time: date_time.map(times => {
                        if (!times.start_time) {
                            return ''
                        }
                        return [times.start_time * 1000, times.end_time * 1000]
                    }),
                    week: row.week ? row.week.split(',').map(item => +item) : [],
                    monment_time: monment_time.map(times => {
                        if (!times.start_moment) {
                            return ''
                        }
                        return [times.start_moment * 1000, times.end_moment * 1000]
                    }),
                    slot_code: row.slot_code,
                    slot_id: row.slot_id,
                    slot_val: row.slot_val
                }
                this.optType = 'editRules'
            }
            this.isOpened = true
        },
        closeDialog() {
            this.isOpened = false
            this.optType = 'addRules'
            this.ruleForm = {
                mobile: '',
                name: '',
                date_time: [''],
                week: [],
                monment_time: [''],
                slot_code: '',
                slot_id: '',
                slot_val: ''
            }
        },
        querySearch(queryString, cb) {
            this.ruleForm.slot_id = ''
            if (!queryString.trim()) {
                cb([])
                return
            }
            if (isLimit) {
                return
            }
            isLimit = true
            setTimeout(async () => {
                const res = await getSlot(queryString)
                cb(res.data)
                isLimit = false
            }, 30)
        },
        handleSelect(option) {
            this.ruleForm.slot_id = option.id
            this.ruleForm.slot_code = option.slot_code
        },
        addTime(type) {
            this.ruleForm[type].push('')
        },
        deleteTime(index, type) {
            this.$confirm('确认删除？').then(() => {
                this.ruleForm[type].splice(index, 1)
                if (this.ruleForm[type].length === 0) {
                    this.addTime(type)
                }
            })
        },
        async confirm() {
            let hasEmpty = false
            let errorMessage = '手机号不能为空'
            if (!this.ruleForm.mobile) {
                hasEmpty = true
            } else if (this.ruleForm.slot_val && !this.ruleForm.slot_id) {
                hasEmpty = true
                errorMessage = '请选择槽值'
            } else if (this.ruleForm.date_time.length > 1 && this.ruleForm.date_time.some(item => !item)) {
                hasEmpty = true
                errorMessage = '存在日期为空'
            } else if (this.ruleForm.monment_time.length > 1 && this.ruleForm.monment_time.some(item => !item)) {
                hasEmpty = true
                errorMessage = '存在时间段为空'
            }
            if (hasEmpty) {
                this.$message.error(errorMessage)
                return
            }
            const res = await addRule(this.optType, {
                ...this.ruleForm, date_time: this.ruleForm.date_time.map(times => {
                    return {
                        start_time: times[0] / 1000,
                        end_time: times[1] / 1000
                    }
                }),
                monment_time: this.ruleForm.monment_time.map(times => {
                    return {
                        start_moment: times[0] / 1000,
                        end_moment: times[1] / 1000
                    }
                })
            })
            if (isSuccess(res.code)) {
                this.$message.success('保存成功')
                this.closeDialog()
                this.getLists()
            }

        },
        handleChange(e, type, key1, key2) {
            if (e) {
                this.searchInfo[type] = {
                    [key1]: e[0] / 1000,
                    [key2]: e[1] / 1000
                }
            } else {
                this.searchInfo[type] = {
                    [key1]: '',
                    [key2]: ''
                }
            }
        },
        resetSearchInfo() {
            this.searchInfo = {
                mobile: '',
                name: '',
                week: '',
                date_time: {
                    start_time: '',
                    end_time: ''
                },
                monment_time: {
                    start_moment: '',
                    end_moment: ''
                }
            }
            this.time = ''
            this.time1 = ''
            this.getLists()
        },
        async deleteItem(row) {
            const res = await deleteRule(row.id)
            if (isSuccess(res.code)) {
                this.$message.success('删除成功')
                this.getLists()
                return
            }
            this.$message.error('删除失败，请重试')
        }

    }
}
</script>

<style lang="scss" scoped>
.rule-setting-container {
    .el-form {
        // position: relative;
        margin-bottom: 20px;
        padding: 10px 0;
        width: 500px;
        // background-color: #f7f8f9;
        // box-sizing: border-box;

        .time-select {
            position: relative;
        }

        .time-select:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    .choose-options {
        .el-select {
            width: 270px;

        }
    }

}
</style>
<style lang="scss">
.rule-setting-container {

    .choose-options {
        .el-select {
            padding: 0 20px;
            width: 270px;
            box-sizing: border-box;

            .el-input {
                margin-left: 0;
                max-width: 100%;
            }
        }
    }

}
</style>